import { FormControl } from '@angular/forms';
import { OfferViewDTO } from './offer-view-dto.type';

export type InsuranceItemCategoryControls = {
  id: FormControl;
  newItemsNature: FormControl;
  quotationRequired: FormControl;
  position: FormControl;
  offers: FormControl;
};

export class InsuranceItemCategory {
  public id?: number;
  public newItemsNature?: string;
  public oldItemsNature?: string;
  public quotationRequired: boolean = false;
  public position?: number;
  public offers: OfferViewDTO[] = [];

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.offers = (data.offers || []).map((offer: any) => new OfferViewDTO(offer));
  }

  public serialize() {
    return {
      id: this.id,
      position: this.position,
      newItemsNature: this.newItemsNature,
      oldItemsNature: this.oldItemsNature,
      offers: this.offers.map((offer: OfferViewDTO) => offer.serialize()),
      quotationRequired: this.quotationRequired,
    };
  }
}
